import { matchSorter } from 'match-sorter';
import { useMemo } from 'react';

import { useUsersContext } from '@work4all/data/lib/hooks/users';

import { User } from '@work4all/models/lib/Classes/User.entity';

/**
 * Filters the list of all app users using the given string.
 */
export function useMentionOptions({ text }: { text: string }): User[] {
  const { users } = useUsersContext();

  const activeUsers = useMemo(() => {
    return users.filter((user) => user.hasLeft === false);
  }, [users]);

  const textTrimmed = useMemo(() => text.trim(), [text]);

  const options = useMemo(() => {
    const terms = textTrimmed
      .split(' ')
      .map((term) => term.trim())
      .filter(Boolean);

    if (terms.length === 0) return activeUsers;

    return terms.reduceRight((results, term) => {
      return matchSorter(results, term, { keys: ['lastName', 'firstName'] });
    }, activeUsers);
  }, [activeUsers, textTrimmed]);

  return options;
}
